import { DeviceRow } from 'components/tables/data/device/types';
import P2Regular from 'components/typography/P2Regular';

/**
 * Column for the serial number.
 */
export default function SerialNumberColumn({ data: { serialNumber } }: { data: DeviceRow }) {
  return (
    <P2Regular color="gray.8" lineClamp={3}>
      {serialNumber}
    </P2Regular>
  );
}
